export default [
  {
    id: 0,
    name: '暂不选择'
  },
  {
    id: 1,
    name: '千次曝光（消耗1000元可用）'
  },
  {
    id: 2,
    name: '点击（消耗4000元可用）'
  },
  {
    id: 3,
    name: '表单（消耗10000元可用）'
  },
  {
    id: 4,
    name: '激活（消耗10000元可用）'
  },
  {
    id: 5,
    name: '付费（消耗100000元可用）'
  },
  {
    id: 6,
    name: 'ROI（消耗100000元可用）'
  }
]
